import _regeneratorRuntime from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/var/jenkins_home/workspace/frontend-web-shop/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
// import { tabRightList } from "./tabs-mock-data.js";
export default {
  data: function data() {
    return {
      // tabRightList,
      leftTabList: [],
      isShow: false,
      showSecIndex: -1,
      classId: "",
      level: "",
      isShowSec: false,
      childList: [],
      img: require("./images/left_icon_03.png")
    };
  },
  computed: {
    bgColor: function bgColor() {
      return this.$route.name === "home";
    },
    gettablist: function gettablist() {
      return this.$store.state.tablist;
    }
  },
  props: {
    activeIndex: {
      //右侧高亮索引
      type: [String, Number],
      default: 0
    },
    isHover: {
      //左侧是否有悬浮功能
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (_this.gettablist.length > 0) {} else {
              _this.$store.dispatch('gettablist');
            }
            _context.next = 3;
            return _this.leftDataList();
          case 3:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    onMouseSecIn: function onMouseSecIn(idx) {
      this.showSecIndex = idx;
      this.childList = this.leftTabList[idx].childList;
      // this.leftTabList
    },
    onMouseSecOut: function onMouseSecOut() {
      this.showSecIndex = -1;
      this.isShowSec = false;
    },
    goPath1: function goPath1() {
      this.$router.push({
        path: '/'
      });
    },
    goPath: function goPath(item) {
      this.$emit("getCurrentData", item);
    },
    onMouseIn: function onMouseIn(event) {
      this.$emit("onHover", true);
      event.stopPropagation();
      if (this.isHover) {
        this.isShow = true;
      }
    },
    onMouseOut: function onMouseOut() {
      this.$emit("onHover", false);
      event.stopPropagation();
      if (this.isHover) {
        this.isShow = false;
      }
    },
    leftDataList: function leftDataList() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var URL, result, dataSource;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              URL = "/pjyy-deepexi-product-center/api/v1/background/PcCatalog/pageList";
              _context2.next = 3;
              return _this2.$getHttpClient().post(URL);
            case 3:
              result = _context2.sent;
              if (result && result.data.code === "200") {
                dataSource = result.data.data;
                _this2.leftTabList = dataSource;
                _this2.leftTabList.forEach(function (element) {
                  element.thirdProList = [];
                  if (element.childList && element.childList.length > 0) {
                    element.childList.forEach(function (ele) {
                      if (ele.childList && ele.childList.length > 0) {
                        ele.childList.forEach(function (el) {
                          element.thirdProList.push({
                            value: el.catalogName,
                            id: el.id
                          });
                        });
                      }
                    });
                  } else {
                    element.childList = [{
                      catalogName: element.catalogName,
                      id: element.id
                    }];
                  }
                });
              }
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    // 点击分类to商品列表
    toProduct: function toProduct(val) {
      this.isShowSec = false;
      this.isShow = false;
      this.classId = val.id;
      this.level = val.level;
      this.$router.push({
        name: "productList",
        params: {
          id: this.classId,
          level: this.level
        }
      });
    },
    leftWrapMouseIn: function leftWrapMouseIn() {
      this.isShowSec = true;
    },
    leftWrapMouseOut: function leftWrapMouseOut() {
      this.isShowSec = false;
    }
  }
};